<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-md">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: [],
  components: {PageLoader},
  data() {
    return {
      isModalShown: true
    }
  },
  methods: {
    CloseModal() {
      this.$emit('closeWufoo');
    },
    ShowWufoo() {
      var k7u0thh08lm2zg;(function(d, t) {
      var s = d.createElement(t), options = {
      'userName':'evf',
      'formHash':'k7u0thh08lm2zg',
      'autoResize':true,
      'height':'580',
      'async':true,
      'host':'wufoo.com',
      'header':'show',
      'ssl':true,
      'defaultValues':'field15=FALSE'};
      s.src = ('https:' == d.location.protocol ? 'https://' : 'http://') + 'www.wufoo.com/scripts/embed/form.js';
      s.onload = s.onreadystatechange = function() {
      var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return;
      try { k7u0thh08lm2zg = new WufooForm();k7u0thh08lm2zg.initialize(options);k7u0thh08lm2zg.display(); } catch (e) {}};
      var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr);
      })(document, 'script');
      this.isWufooLoading = false;
    }
  },
  created() {
    this.isWufooLoading = true;
    this.ShowWufoo();
  },
};
</script>


// WEBPACK FOOTER //
// PortalForm.vue?f97d5c40